import React, { useEffect, useState, memo } from 'react'
import { useSelector } from 'react-redux'
import './applicantDetail.scss'
import { getSummaryInfo } from 'actions/applicants'
import emptyIcon from 'styles/images/icons/empty.svg'
import strings from 'strings'
import Loader from 'components/shared/Loader'

const summaryStrings = strings.APPLICANT.SUMMARY

const SummaryCard = memo(function Summary({ 
    applicantId, 
    updates, 
    isReadOnly = false,
    getSummaryInfoFn = null, // Optional marketplace function override
    isApplicationOffer = false // Flag to determine which Redux state to use
}) {
    const [summaryInfo, setSummaryInfo] = useState([])
    const [additionalSummaryInfo, setAdditionalSummaryInfo] = useState([])
    const updateFromRedux = useSelector(state => 
        isApplicationOffer 
            ? state.applicationOffers?.updateSummary || 0
            : state.applicant?.updateSummary || 0
    )

    const [loadingSummary, setLoadingSummary] = useState(false)

    useEffect(() => {
        if (summaryInfo?.length === 0) setLoadingSummary(true);
        const summaryFunction = getSummaryInfoFn || getSummaryInfo;
        
        if (typeof summaryFunction !== 'function') {
            console.error('summaryFunction is not a function:', typeof summaryFunction);
            setLoadingSummary(false);
            return;
        }
        
        const apiCall = summaryFunction(applicantId);
        if (typeof apiCall !== 'function') {
            console.error('summaryFunction did not return a function:', typeof apiCall);
            setLoadingSummary(false);
            return;
        }
        
        apiCall()
            .then((res) => {
                const summaryData = res?.summary || [];
                const additionalSummaryData = res?.additionalSummary || [];
                const validSummaryData = Array.isArray(summaryData) ? 
                    summaryData.filter(item => item && item.childs && Array.isArray(item.childs)) : [];
                const validAdditionalSummaryData = Array.isArray(additionalSummaryData) ? 
                    additionalSummaryData.filter(item => item && item.childs && Array.isArray(item.childs)) : [];
                
                setSummaryInfo(validSummaryData);
                setAdditionalSummaryInfo(validAdditionalSummaryData);
            })
            .catch((error) => {
                console.error('Error fetching summary info:', error);
            })
            .finally(() => {
                setLoadingSummary(false);
            });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [updates, applicantId, updateFromRedux, getSummaryInfoFn]);

    const TwoColumnLayout = (mode, leftText, desc, status, index) => {
        return (
            <div className={mode === 'MULTIPLE_ELEMENTS' ? 'd-flex mt-1' : 'd-flex mt-3'} key={index}>
                <div className='d-flex align-items-center flex-fill'>
                    <div className={mode === 'ONE_ELEMENT' ? 'itemName' : 'itemEntityName'}>
                        {leftText}
                    </div>
                </div>
                {DescriptionAndStatus(desc, status)}
            </div>
        )
    }

    const summaryItem = ({ item, index }) => {
        // Safety check for item structure
        if (!item || !item.childs || !Array.isArray(item.childs)) {
            console.warn('Invalid summary item structure:', item);
            return null;
        }

        return (
            <div key={index}>
                <hr></hr>

                {item.childs.length === 1 ?
                 TwoColumnLayout('ONE_ELEMENT', item.name, item.childs[0].description, item.childs[0].status, 0) :
                 <>
                    <div className='mt-3'>
                            <div className='itemName mb-2'>
                                {item.name}
                            </div>

                            {item.childs.map((child, childIndex) => (
                                TwoColumnLayout('MULTIPLE_ELEMENTS', child.entityName, child.description, child.status, childIndex)
                        ))}
                    </div>
                 </>
                }

            </div>
        )
    }


    function DescriptionAndStatus(description, status) {
        return <div className='d-flex summaryDescriptionAndStatus'>
            <div className='flex-fill d-flex itemDescriptionContainer align-middle'>
                <p className='itemDescription'>{description}</p>
            </div>

            <div className='statusContainer'>
                <div className={`itemStatus ${status.toLowerCase()}StatusColor`}></div>
            </div>
        </div>
    }



    const NoDataIndication = (props) => {
        return (
            <div className='summaryNoDataIndication mt-5'>
                <img src={emptyIcon} alt='empty' />
                <p className='mt-1'>{props.message}</p>
            </div>
        )
    }

    return (
        <>
            <div className='summary tabPanel' id='summary'>
                <h5 className='mb-4'>{summaryStrings.SUMMARY_TITLE}</h5>
                {
                    loadingSummary
                        ? <div className='mt-5'><Loader /></div>
                        :
                        summaryInfo?.length === 0
                            ? <NoDataIndication message={summaryStrings.NO_SUMMARY_DATA} />
                            :
                            summaryInfo?.map((item, index) => summaryItem({ item, index }))
                }
            </div>
            <div className='summary tabPanel' id='summary2'>
                <h5 className='mb-4'>{summaryStrings.INSIGHTS_TITLE}</h5>
                {
                    loadingSummary
                        ? <div className='mt-5'><Loader /></div>
                        :
                        additionalSummaryInfo?.length === 0
                            ? <NoDataIndication message={summaryStrings.NO_INSIGHTS_DATA} />
                            :
                            additionalSummaryInfo?.map((item, index) => summaryItem({ item, index }))
                }
            </div>
        </>
    )


})

export default SummaryCard